/**
 * 菜单模块 - 枚举类型定义
 * 
 * @file-purpose 定义菜单模块相关的枚举类型
 * @backend-file backend/app/Models/Menu.php
 * 
 * @attention
 * 1. 枚举值必须与后端 Model 常量完全一致（包括大小写）
 * 2. 从 constants/status.ts 导入系统级枚举常量
 * 3. 新增枚举必须同步更新 constants.ts 中的 LABELS 对象
 * 
 * @update-timing
 * - 后端新增菜单类型时
 * - 后端新增平台类型时
 * - 后端新增状态类型时
 * 
 * @validation
 * 1. 对照 backend/app/Models/Menu.php 的常量定义
 * 2. 确保所有枚举值与后端一致
 * 3. 运行 TypeScript 编译检查
 * 
 * @author YSFL Team
 * @last-updated 2025-10-18
 */

/**
 * 菜单类型枚举
 * 
 * @description 定义菜单的显示类型
 * @backend Model::TYPE_*
 */
export enum MenuType {
  /** 目录 - 不对应具体页面，用于分组 */
  CATALOG = 'catalog',
  /** 菜单 - 对应具体页面 */
  MENU = 'menu',
  /** 按钮 - 页面内的操作按钮权限 */
  BUTTON = 'button',
  /** 内嵌 - 内嵌iframe页面 */
  EMBEDDED = 'embedded',
  /** 外链 - 外部链接 */
  LINK = 'link',
}

/**
 * 菜单平台枚举
 * 
 * @description 定义菜单所属的平台
 * @backend Model::PLATFORM_*
 */
export enum MenuPlatform {
  /** Web端 */
  WEB = 'web',
  /** App端 */
  APP = 'app',
}

/**
 * 菜单状态枚举
 * 
 * @description 定义菜单的启用状态
 * @backend Model::STATUS_*
 */
export enum MenuStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1,
}

/**
 * 外链打开方式枚举
 * 
 * @description 定义外链的打开方式
 */
export enum LinkTarget {
  /** 新窗口打开 */
  BLANK = '_blank',
  /** 当前窗口打开 */
  SELF = '_self',
}

/**
 * 徽标类型枚举
 * 
 * @description 定义徽标的显示类型
 */
export enum BadgeType {
  /** 圆点 */
  DOT = 'dot',
  /** 数字/文本 */
  NORMAL = 'normal',
}

/**
 * 徽标变体枚举
 * 
 * @description 定义徽标的颜色主题
 */
export enum BadgeVariant {
  /** 默认 */
  DEFAULT = 'default',
  /** 危险/删除 */
  DESTRUCTIVE = 'destructive',
  /** 成功 */
  SUCCESS = 'success',
  /** 警告 */
  WARNING = 'warning',
}

